import { createAction, props } from '@ngrx/store';
import { TimeSlots, TimeSlotsDTO, TimeSlotsFilters } from '../../commons/models/timeslots';

export const loadTimeSlots = createAction('[Time Slots] Load Time Slots', props<{ page?: number, perPage?: number, order?: string, direction?: string, filters?: TimeSlotsFilters, includes?: string[] }>());
export const loadTimeSlotsCompleted = createAction('[Time Slots] Load Time Slots Completed', props<{ timeslots: TimeSlotsDTO[], currentPage: number, total: number, perPage: number, order?: string, direction?: string, filters?: TimeSlotsFilters, includes?: string[] }>());
export const loadTimeSlotsFailed = createAction('[Time Slots] Load Time Slots Failed', props<{ error: any }>());

export const changePage = createAction('[Time Slots] Change page', props<{ page: number, size: number }>());
export const changeSort = createAction('[Time Slots] Change sort', props<{ order: string, direction: string }>());
export const changeFilters = createAction('[Time Slots] Change filters', props<{ filters: TimeSlotsFilters }>());

export const editTimeSlot = createAction('[Time Slots] Edit time slot', props<{ timeslot: TimeSlots }>());
export const timeSlotDialogOpened = createAction('[Time Slots] Detail dialog opened', props<{ dialogId: string }>());
export const closeTimeSlotsDialog = createAction('[Time Slots] Close detail dialog');
export const requestCloseTimeSlotsDialog = createAction('[Time Slots] Request Close Dialog');
export const confirmCloseTimeSlotsDialog = createAction('[Time Slots] Confirm Close Dialog');
export const cancelCloseTimeSlotsDialog = createAction('[Time Slots] Cancel Close Dialog');


export const showTimeSlots = createAction('[Time Slots] Show time slot', props<{ timeslot: TimeSlotsDTO }>());
export const addTimeSlots = createAction('[Time Slots] Add time slot');
export const loadTimeSlot = createAction('[Time Slots] Load time slot', props<{ id: number }>());
export const loadTimeSlotCompleted = createAction('[Time Slots] Load time slot Completed', props<{ timeslot: TimeSlotsDTO }>());
export const loadTimeSlotFailed = createAction('[Time Slots] Load time slot Failed', props<{ error: any }>());

export const saveTimeSlot = createAction('[Time Slots] Save time slot', props<{ timeslots: TimeSlots }>());
export const saveTimeSlotCompleted = createAction('[Time Slots] Save time slot completed', props<{ timeslot: TimeSlotsDTO }>());
export const saveTimeSlotFailed = createAction('[Time Slots] Save time slot failed', props<{ error: any }>());

export const deleteTimeSlot = createAction('[Time Slots] Delete time slot', props<{ timeslot: TimeSlotsDTO }>());
export const deleteTimeSlotCompleted = createAction('[Time Slots] Delete time slot completed', props<{ timeslot: TimeSlotsDTO }>());
export const deleteTimeSlotCancelled = createAction('[Time Slots] Delete time slot cancelled');
export const deleteTimeSlotFailed = createAction('[Time Slots] Delete time slot failed', props<{ error: any }>());

export const selectTimeSlot = createAction('[Time Slots] Select time slot', props<{ filters?: TimeSlotsFilters }>());
export const selectionDialogOpened = createAction('[Time Slots] Selection dialog opened', props<{ selectionDialogId: string }>());
export const closeSelectionDialog = createAction('[Time Slots] Close selection dialog');
export const timeSlotSelected = createAction('[Time Slots] Time slot selected', props<{ timeslot: TimeSlotsDTO }>());

export const addSelectTimeSlots = createAction('[Time Slots] Add selected time slot', props<{ timeslot: TimeSlots }>());
export const removeSelectedTimeSlots = createAction('[Time Slots] Remove selected time slots', props<{ timeslot: TimeSlots }>());
export const resetSelectedTimeSlots = createAction('[Time Slots] Reset selected time slots');
export const selectTimeSlotSuccess = createAction('[Time Slots] Select time slot Success', props<{ timeslot: TimeSlots }>());

export const proceedWithSaveTimeSlot = createAction('[TimeSlot] Proceed with Save', props<{ timeslots: TimeSlots }>());
  




